module.exports = __webpack_public_path__ + "img/pitesti.71744b02.jpg";